var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-carousel",
    {
      staticStyle: { width: "100%" },
      attrs: {
        interval: 5000,
        "indicator-position": "none",
        arrow: "never",
        height: "100vh"
      },
      on: { change: _vm.changeCarousel }
    },
    _vm._l(_vm.bg, function(item) {
      return _c("el-carousel-item", { key: item }, [
        _c("div", {
          staticStyle: { height: "100vh" },
          style:
            "background:url(" +
            item +
            ") no-repeat;background-size:cover;background-position:50% 50%"
        })
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }